import React from "react";

const TermsConditionsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8 md:p-12">
        {/* Header */}
        <div className="mb-10 pb-8 border-b-2 border-gray-200">
          <h1 className="text-h2 text-dark4 mb-4">Terms & Conditions</h1>
          <p className="text-bodyMR text-dark5">
            Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>

        {/* Content */}
        <div className="space-y-8">
          {/* Introduction */}
          <section className="space-y-4">
            <p className="text-bodyLR text-dark5 leading-relaxed">
              Welcome to Testament.digital. These Terms and Conditions ("Terms") govern your use of our platform
              and services. By accessing or using our services, you agree to be bound by these Terms.
            </p>
          </section>

          {/* Section 1 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">1. Acceptance of Terms</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. 
              It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. 
              Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of 
              the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the 
              cites of the word in classical literature, discovered the undoubtable source.
            </p>
          </section>

          {/* Section 2 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">2. Use of Service</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" 
              (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on 
              the theory of ethics, very popular during the Renaissance.
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li className="text-bodyMR text-dark5">You must be at least 18 years old to use our service</li>
              <li className="text-bodyMR text-dark5">You are responsible for maintaining the confidentiality of your account</li>
              <li className="text-bodyMR text-dark5">You agree to provide accurate and complete information</li>
            </ul>
          </section>

          {/* Section 3 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">3. Intellectual Property</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. 
              The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.
            </p>
          </section>

          {/* Section 4 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">4. Privacy and Data Protection</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also 
              reproduced in their exact original form, accompanied by English versions from the 1914 
              translation by H. Rackham.
            </p>
          </section>

          {/* Section 5 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">5. Limitation of Liability</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              To the fullest extent permitted by law, Testament.digital shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages, or any loss of profits or revenues, 
              whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses.
            </p>
          </section>

          {/* Section 6 */}
          <section className="space-y-4">
            <h2 className="text-h5 text-dark4 font-semibold">6. Changes to Terms</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              We reserve the right to modify these Terms at any time. We will notify users of any material 
              changes by posting the new Terms on this page and updating the "Last updated" date. 
              Your continued use of the service after such changes constitutes your acceptance of the new Terms.
            </p>
          </section>

          {/* Contact Section */}
          <section className="mt-12 pt-8 border-t-2 border-gray-200">
            <h2 className="text-h5 text-dark4 font-semibold mb-4">Contact Us</h2>
            <p className="text-bodyMR text-dark5 leading-relaxed">
              If you have any questions about these Terms & Conditions, please contact us at{" "}
              <a href="mailto:support@testament.digital" className="text-primary hover:underline">
                support@testament.digital
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditionsPage;
